"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
;
//# sourceMappingURL=interface.js.map